import { render, staticRenderFns } from "./PaginatedDropdown.vue?vue&type=template&id=35f391de"
import script from "./PaginatedDropdown.vue?vue&type=script&lang=js"
export * from "./PaginatedDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports